import { render, staticRenderFns } from "./SurveyManagementNewQuestion.vue?vue&type=template&id=7d4dd7ac&scoped=true&"
import script from "./SurveyManagementNewQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementNewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementNewQuestion.vue?vue&type=style&index=0&id=7d4dd7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4dd7ac",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementNewQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4dd7ac')) {
      api.createRecord('7d4dd7ac', component.options)
    } else {
      api.reload('7d4dd7ac', component.options)
    }
    module.hot.accept("./SurveyManagementNewQuestion.vue?vue&type=template&id=7d4dd7ac&scoped=true&", function () {
      api.rerender('7d4dd7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/SurveyManagementNewQuestion.vue"
export default component.exports